import { DishModel } from '../pages/pub-menu/create/builder/models'
import { AppStore } from '../stores/AppStore'

export const getUnits = (dish: DishModel, language: string) => {
  const unitGroup = AppStore?.localisedUnits?.find(
    (unitGroup) => unitGroup.locale.locale === language
  )
  const unit = unitGroup?.units.find((unit) => unit.id === dish.unit?.id)

  return unit?.code ?? dish.unit?.code
}
